export enum HubHeader {
  TotalItems = 'x-hub-total',
}

export enum Scope {
  RegionContent = 'region-content',
  HPSContent = 'hps-content',
  SuperuserContent = 'superuser-content',
}

export type ScopeItem = { scope: Scope; title: string }

export const ScopeItems = Array<ScopeItem>(
  { scope: Scope.RegionContent, title: 'Регион контент' },
  { scope: Scope.HPSContent, title: 'ВПШ контент' },
  { scope: Scope.SuperuserContent, title: 'Суперпользователь' }
)

export enum Role {
  Anonymous = 0,
  HasFirstData = 1,
  EmailOnly = 2,
  PhoneNumberOnly = 3,
  EmailPhoneNumberOnly = 4,
  Simple = 10,
  ExternalService = 11,
  Registered = 12,
  Activist = 15,
  Member = 16,
  Staff = 17,
  RegionStaff = 20,
  Editor = 30,
  HPSEditor = 31,
  YasLDPREditor = 32,
  VstupiOperator = 33,
  HPSListener = 100,
  MOCoordinatorPrimary = 200,
  MOCoordinator = 201,
  ROSMM = 299,
  ROPress = 300,
  ROCoordinator = 301,
  DeputyCandidate = 399,
  DeputyMS = 400,
  DeputyCR = 401,
  DeputyRO = 402,
  DeputyGD = 403,
  CAJurist = 500,
  CAAgit = 520,
  CACKRK = 550,
  CAOrg = 600,
  OneC = 9900,
  Superuser = 10000,
}

export const Roles: Array<Role> = [
  Role.Anonymous,
  Role.HasFirstData,
  Role.EmailOnly,
  Role.PhoneNumberOnly,
  Role.EmailPhoneNumberOnly,
  Role.Simple,
  Role.ExternalService,
  Role.Registered,
  Role.Activist,
  Role.Member,
  Role.Staff,
  Role.RegionStaff,
  Role.Editor,
  Role.YasLDPREditor,
  Role.VstupiOperator,
  Role.HPSEditor,
  Role.HPSListener,
  Role.MOCoordinatorPrimary,
  Role.MOCoordinator,
  Role.ROSMM,
  Role.ROPress,
  Role.ROCoordinator,
  Role.DeputyCandidate,
  Role.DeputyMS,
  Role.DeputyCR,
  Role.DeputyRO,
  Role.DeputyGD,
  Role.CAJurist,
  Role.CAAgit,
  Role.CACKRK,
  Role.CAOrg,
  Role.OneC,
  Role.Superuser,
]
export function roleString(role: Role): string {
  switch (role) {
    case Role.Anonymous:
      return 'Анонимный'
    case Role.HasFirstData:
      return 'Имеет первичные поля'
    case Role.EmailOnly:
      return 'Имеет только подтвержденный email'
    case Role.PhoneNumberOnly:
      return 'Имеет только подтвержденный номер телефона'
    case Role.EmailPhoneNumberOnly:
      return 'Имеет подтвержденные email и номер телефона'
    case Role.Simple:
      return 'Простой'
    case Role.ExternalService:
      return 'Внешний сервис'
    case Role.Registered:
      return 'Зарегистрированный'
    case Role.Activist:
      return 'Активист'
    case Role.Member:
      return 'Член партии'
    case Role.Staff:
      return 'Имеющий отношение к партии ???'
    case Role.RegionStaff:
      return 'Сотрудник регионального отделения'
    case Role.Editor:
      return 'Редактор (модератор) пресс службы ЛДПР'
    case Role.YasLDPREditor:
      return 'Редактор (модератор) проекта Я с ЛДПР'
    case Role.VstupiOperator:
      return '35 лет ЛДПР оператор'
    case Role.HPSEditor:
      return 'Редактор ВПШ'
    case Role.HPSListener:
      return 'Слушатель курсов ВПШ'
    case Role.MOCoordinatorPrimary:
      return 'Координатор первичного отделения'
    case Role.MOCoordinator:
      return 'Координатор местного отделения'
    case Role.ROSMM:
      return 'SMM регионального отделения'
    case Role.ROPress:
      return 'Пресс секретарь регионального отделения'
    case Role.ROCoordinator:
      return 'Координатор Регионального отделения'
    case Role.DeputyMS:
      return 'Депутат Местного самоуправления'
    case Role.DeputyCandidate:
      return 'Кандидат в депутаты'
    case Role.DeputyCR:
      return 'Депутат Центра субъекта'
    case Role.DeputyRO:
      return 'Депутат Регионального парламента'
    case Role.DeputyGD:
      return 'Центральный аппарат Депутат ГД'
    case Role.CAJurist:
      return 'Центральный аппарат Юридический отдел'
    case Role.CAAgit:
      return 'Центральный аппарат Агитация и пропаганда'
    case Role.CACKRK:
      return 'Центральный аппарат ЦКРК'
    case Role.CAOrg:
      return 'Центральный аппарат Орг отдел'
    case Role.Superuser:
      return 'Суперпользователь'
  }
  return 'не известный тип'
}

export enum PositionKind {
  CAOrg = 1,
  CACKRK = 2,
  CAAgit = 3,
  CAJurist = 4,
  DeputyGD = 100,
  DeputyRO = 101,
  DeputyCR = 102,
  DeputyMS = 103,
  DeputyCandidate = 104,
  ROCoordinator = 120,
  ROPress = 121,
  ROSMM = 122,
  MOCoordinator = 200,
  MOCoordinatorPrimary = 201,
  HighSchoolListener = 210,
  Unknown = 255,
}
